<app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
  [contentTableArray]="contentTableArray" [content_Details]="content_Details" (closecontentpopup)="closecontentpopup()"
  [tablevalues]="tablevalues" [tablekeys]="tablekeys">
</app-contentpopup>
<p *ngIf="ShowLmsMessage != ''" style="color: red; font-weight: bold; text-align: center; text-decoration: underline;">
  {{ ShowLmsMessage }}
</p>
<table class="table table-bordered" id="excel-table">
  <div class="table-responsive">
    <thead *ngIf="!this.paramsValues.section">
      <tr>
        <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
        <th></th>
        <th>
          <i class="fa fa-edit icons" (click)="editbtn()"></i>
          <i class="fa fa-download icons" title="Dowload file" (click)="downloadFiles()"></i>
          <i class="fa fa-check-square icons" title="Download upon selection" (click)="downloadSelected()"></i>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
        [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }">
        <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
            (click)="selected_checbox(Obj.key, index)" /></td>
        <td #headerids
          [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }"
          [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator)]">
          {{Obj.key}}
          <span class="tooltip-container">
            <i class="fas fa-info-circle info-icon"></i>
            <div class="custom-tooltip" [innerHTML]="getTooltipContent(Obj.key)"></div>
          </span>
          <div class="action-buttons">
            <button pButton [label]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'Verified' : 'Verify'"
              class="custom-button verify-btn" (click)="verifyField(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'not-allowed' : 'pointer' }">
            </button>

            <button pButton
              [label]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'Under Review' : 'Review'"
              class="custom-button review-btn" (click)="openReviewDialog(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'not-allowed' : 'pointer' }">
            </button>
          </div>
        </td>
        <td>
          <div *ngIf="Obj.value | arrayChk;else displayvalue;let is=index">
            <div *ngIf="Obj.value | tableChk;else list">
              <div class="table-responsive">
                <table class="table table-bordered" id="innertable">
                  <thead style="font-size: 12px;">
                    <tr>
                      <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader">
                        <p>{{headers}}</p>
                        <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 10px;">
                    <tr *ngFor="let trows of Obj.value | tableBody ;let m=index">
                      <td *ngFor="let rdata of trows;let iindex =index">
                        <p [ngClass]="[showedit?'editcls':'editdisable']">
                          <input type="text"
                            (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                            [ngClass]="[rdata.length>=20?'input-size':'']" value={{rdata}} id={{rdata}} />
                        </p>
                        <p [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                          {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key ===
                          'Food effect' || Obj.key === 'Indications and Usage' ||Obj.key === 'Variability (%
                          ISCV)'||Obj.key === 'PK Linearity'||Obj.key === 'Pharmacology'? '': rdata}}
                        </p>
                      </td>
                      <i *ngIf="Obj.value.length > 1 && showedit" [ngClass]="['editcls']"
                        style="font-size: 20px; cursor: pointer; margin: 10px;" class="fas fa-trash float-left"
                        (click)="deleteRow(Obj.value, m)">
                      </i>
                    </tr>

                    <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                      class="fas fa-plus float-left"
                      (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                    <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                        *ngIf="Obj.value.length>sliceEnd" class="btn btn-success"
                        (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show More</button> -->

                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #list>
              <ul>

                <li *ngFor="let lItems of Obj.value ;let inds=index">
                  <p [ngClass]="[showedit?'editcls':'editdisable']">
                    <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                    <textarea [ngClass]="[lItems.length>=20?'input-size':'']"
                      (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" style="height: 30px;"
                      value={{lItems}} cols="30" rows="10"></textarea>
                    <i *ngIf="Obj.value.length > 1 && inds > 0" class="fas fa-trash"
                      style="font-size: 20px; cursor: pointer; margin-left: 10px;"
                      (click)="deleteListItem(Obj.value, Obj.key, inds)"></i>
                  </p>
                  <p [ngClass]="[!showedit?'editcls':'editdisable']">

                    {{lItems}}

                  </p>

                </li>
                <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                  class="fas fa-plus float-left" (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>
                <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                    *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                    class="btn btn-success"
                    (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                    More</button> -->

              </ul>
            </ng-template>
          </div>
          <ng-template #displayvalue>
            <p
              [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                (change)="editdata($event,Obj.value,Obj.key,index,'')" />
            </p>
            <p
              [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              {{Obj.value}}

            </p>
            <!-- <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;" class="fas fa-plus float-left"
              (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i> -->
            <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;" class="fas fa-plus float-left"
              (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i>

            <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
            <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div>
          </ng-template>

          <div *ngFor="let edited of isChanged(Obj.key)">
            <div *ngIf="edited === Obj.key" [id]="Obj.key">
              <i class="fa fa-check" title="Accept" (click)="handelAction(Obj,'accept')"
                style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
              <i class="fa fa-remove" title="Reject" (click)="handelAction(Obj,'reject')"
                style="cursor: pointer;padding-left:3rem;color:red"></i>
            </div>
          </div>

        </td>
      </tr>
      <tr>
        <td *ngIf="showCheckBox">
          <button class="btn btn-primary" (click)="downloadSelectedData()">Download</button>
        </td>
      </tr>
    </tbody>
  </div>
</table>
<p-dialog header="Review Entry" [(visible)]="displayReviewDialog" [modal]="true" [closable]="false"
  class="custom-dialog">
  <div class="dialog-content">
    <div class="p-field">
      <label for="email">Select Email:</label>
      <p-dropdown [options]="emailList" [(ngModel)]="selectedEmail" placeholder="Select Email">
      </p-dropdown>
      <div *ngIf="submitted && !selectedEmail" class="error-text">
        Email is required.
      </div>
    </div>

    <div class="p-field">
      <label for="key">Key Name:</label>
      <input id="key" type="text" pInputText [(ngModel)]="selectedKey" readonly class="readonly-input">
    </div>

    <div class="p-field">
      <label for="comment">Comment:</label>
      <textarea id="comment" pInputTextarea [(ngModel)]="reviewComment" rows="2" cols="40"
        class="comment-box"></textarea>
      <small class="comment-warning">
        {{ reviewComment.length < 15 ? 'Minimum 15 characters required.' : '&nbsp;' }} </small>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Cancel" class="cancel-btn"
      (click)="displayReviewDialog = false"></button>
    <button type="button" pButton icon="pi pi-check" label="Submit" class="submit-btn" [disabled]="!isCommentValid()"
      (click)="submitReview()"></button>
  </p-footer>
</p-dialog>
<div *ngIf="showedit" class="text-center">
  <button class="btn btn-primary" (click)="saveEdit()">Save</button>
</div>